import {
  AudiencePricingStructure,
  AudienceType,
  DSP,
  Option,
} from "@intentsify/types";

function generateUIOptionValues(e: object): Option[] {
  return Object.entries(e)
    .filter(([, val]) => Number(val) !== 0)
    .map(
      ([key, val]) =>
        ({
          value: key,
          label: val,
        } as Option)
    );
}

export const audienceTypeDesc = {
  [AudienceType.SYNDICATED]: "Syndicated",
  [AudienceType.CUSTOM]: "Custom",
};

export const audienceTypeOptions = generateUIOptionValues(audienceTypeDesc);

const pricingStructureDesc = {
  [AudiencePricingStructure.CPM]: "CPM",
  [AudiencePricingStructure.PERCENT_MEDIA]: "Percent Media",
  [AudiencePricingStructure.HYBRID]: "Hybrid",
};

export const pricingStructureOptions =
  generateUIOptionValues(pricingStructureDesc);

const DSPDesc = {
  [DSP.GOOGLE_DV360]: DSP.GOOGLE_DV360,
  [DSP.THE_TRADE_DESK]: DSP.THE_TRADE_DESK,
  [DSP.AMAZON_DSP]: DSP.AMAZON_DSP,
  [DSP.STACK_ADAPT]: DSP.STACK_ADAPT,
  [DSP.LINKEDIN_ADS]: DSP.LINKEDIN_ADS,
  [DSP.META]: DSP.META,
  [DSP.X]: DSP.X,
  [DSP.TIKTOK_FOR_BUSINESS]: DSP.TIKTOK_FOR_BUSINESS,
  [DSP.PINTEREST]: DSP.PINTEREST,
  [DSP.SNAPCHAT]: DSP.SNAPCHAT,
  [DSP.ADOBE]: DSP.ADOBE,
  [DSP.VIANT]: DSP.VIANT,
  [DSP.MOUNTAIN]: DSP.MOUNTAIN,
  [DSP.BASIS]: DSP.BASIS,
  [DSP.ILLUMIN]: DSP.ILLUMIN,
  [DSP.PUBMATIC]: DSP.PUBMATIC,
  [DSP.RTB_HOUSE]: DSP.RTB_HOUSE,
  [DSP.SAMSUNG_ADS]: DSP.SAMSUNG_ADS,
  [DSP.MEDIAMATH_BY_INFILLION]: DSP.MEDIAMATH_BY_INFILLION,
  [DSP.SIMPLI_FI]: DSP.SIMPLI_FI,
  [DSP.MADHIVE]: DSP.MADHIVE,
  [DSP.PARAMOUNT]: DSP.PARAMOUNT,
  [DSP.LG_AD_SOLUTIONS]: DSP.LG_AD_SOLUTIONS,
  [DSP.WARNER_BROS_DISCOVERY]: DSP.WARNER_BROS_DISCOVERY,
  [DSP.COX_MEDIA]: DSP.COX_MEDIA,
  [DSP.SPECTRUM_CHARTER]: DSP.SPECTRUM_CHARTER,
};

export const DSPOptions = generateUIOptionValues(DSPDesc);

export const audienceTargetOptions = [
  { label: "B2B", value: "B2B" },
  { label: "B2C", value: "B2C" },
];

export const generateOptionsForLabels = (lables: string[]) => {
  if (!lables) {
    return [];
  }

  return lables.map((label) => ({ label: label, value: label }));
};

export const YesNoSelectOptions = [
  { label: "Y", value: 1 },
  { label: "N", value: 0 },
];

export const categoryOptions = [
  { label: "Firmographics", value: "Firmographics" },
  { label: "Demographics", value: "Demographics" },
  { label: "Technographics", value: "Technographics" },
  { label: "Intent Data", value: "Intent Data" },
  { label: "Segment Grouping", value: "Segment Grouping" },
];

export const criteriaOptions = [
  { label: "Biotechnology Intent", value: "Biotechnology Intent" },
  { label: "Business Events", value: "Business Events" },
  { label: "Business Intent", value: "Business Intent" },
  {
    label: "Business Size Classification",
    value: "Business Size Classification",
  },
  { label: "Decision Maker", value: "Decision Maker" },
  { label: "Employee Count", value: "Employee Count" },
  {
    label: "Energy/Construction/Manufacturing Intent",
    value: "Energy/Construction/Manufacturing Intent",
  },
  { label: "Finance Intent", value: "Finance Intent" },
  { label: "Fortune 500", value: "Fortune 500" },
  { label: "Government Intent", value: "Government Intent" },
  { label: "HealthCare Intent", value: "HealthCare Intent" },
  { label: "Human Resources Intent", value: "Human Resources Intent" },
  { label: "Industry", value: "Industry" },
  { label: "Job Seniority", value: "Job Seniority" },
  { label: "Job Function", value: "Job Function" },
  { label: "Legal Intent", value: "Legal Intent" },
  { label: "Logistics Intent", value: "Logistics Intent" },
  { label: "Longevity", value: "Longevity" },
  { label: "Marketing Intent", value: "Marketing Intent" },
  { label: "Retail Intent", value: "Retail Intent" },
  { label: "Revenue Size", value: "Revenue Size" },
  { label: "Technologies", value: "Technologies" },
  { label: "Technology Intent", value: "Technology Intent" },
];

export const destinations: Record<number, string> = {
  4466: "Facebook - US",
  4896: "Twitter",
  2428: "Yahoo! (fka Verizon Media)",
  1458: "AOL",
  4516: "Cadent (4INFO)",
  4476: "Pandora",
  1307: "Dstillery",
  1428: "Google | Data Marketplace",
  1336: "Millennial Media / Jumptap",
  2539: "Moasis",
  5976: "Perfect & Complete",
  1738: "Viant",
  1558: "Collective",
  5786: "PulsePoint",
  4456: "Verve",
  5956: "AdForge",
  3946: "Distroscale",
  2719: "Pk4 Media",
  3146: "VideoAmp",
  6796: "StackAdapt",
  6866: "Crucial Interactive",
  6996: "Hooked Media",
  2348: "AdTheorent",
  6976: "Giant Media",
  1388: "Adobe Audience Manager",
  6096: "Peel",
  1498: "Adobe Ad Cloud (formerly TubeMogul)",
  1658: "Chango",
  29: "OneView (DataXu)",
  4136: "RRD (FKA Valassis Digital/Maxpoint)",
  1021: "MediaMath",
  6986: "Jivox",
  1101: "Xandr Invest (FKA AppNexus)",
  7626: "Survata",
  4: "BrightRoll",
  3406: "InMobi",
  6386: "Torrential Inc.",
  7306: "MdotM",
  1938: "Videology",
  8256: "Applift",
  8226: "Vdopia",
  1317: "Salesforce Audience Studio (fka Krux)",
  7056: "Aki Technologies",
  2849: "EyeView Digital",
  1728: "LiveIntent",
  4566: "EyeReturn",
  9076: "Storygize",
  1948: "Tremor Video",
  5316: "Foursquare",
  1356: "The Trade Desk",
  6856: "Undertone",
  3676: "Centro (SiteScout)",
  7086: "Sonobi",
  7586: "TripleLift",
  4756: "Samsung Ads",
  7226: "Emodo",
  7126: "MediaBrix",
  6006: "Lucid",
  1297: "vdx.tv",
  8356: "Adxcel",
  1908: "Tapad",
  7356: "Bidtellect",
  9456: "Appreciate",
  9436: "AdvertServe",
  9739: "Tubi.TV",
  6036: "LG Ad Solutions (Alphonso)",
  8536: "Brandify",
  14: "Rubicon Project",
  6906: "CreditCards.com",
  5036: "Gumgum",
  5026: "Innovid",
  6266: "Instinctive",
  7246: "iQM",
  8396: "Lumate",
  6566: "Markit",
  1528: "Resonate",
  6326: "Sabio",
  8896: "Skydeo",
  5086: "Spongecell",
  4876: "Tapjoy",
  7346: "TargetSpot",
  6926: "Ubermedia - Sync",
  8036: "Virool",
  8126: "Wylei",
  3176: "xAd",
  7536: "Adswizz",
  5966: "Vertical Mass DG",
  1366: "YuMe",
  5456: "Adform",
  9516: "Go2Mobi",
  6556: "inMarket",
  7266: "KBM",
  9276: "Nativo",
  8446: "Smync",
  2679: "Genesis Media",
  5936: "Roku",
  7796: "Clearstream.tv",
  1011: "Zeta DSP (FKA Sizmek/Rocket Fuel)",
  1508: "Acxiom",
  5276: "Zemanta",
  1578: "RadiumOne/RhythmOne",
  7566: "Personagraph",
  5446: "SpotX",
  4639: "Thinknear",
  1408: "Digilant",
  5: "AudienceScience",
  3186: "PlaceIQ",
  7616: "Revjet",
  7486: "Outbrain",
  10769: "BlueCore",
  5336: "Adelphic",
  10499: "Anomaly",
  3366: "AdColony (Opera Mediaworks)",
  6356: "Jun Group",
  7326: "Spotify",
  6396: "Visible Measures",
  11059: "FastG8",
  10549: "AcuityAds",
  11269: "Kiip",
  9556: "Scanbuy",
  8486: "PerformanceHorizon",
  1618: "Rakuten (MediaForge)",
  2959: "Taboola",
  2438: "NinthDecimal",
  11159: "LoopMe",
  0: "LinkedIn",
  1448: "Nexxen (FKA Amobee FKA Turn)",
  7076: "Jampp",
  11099: "SSI",
  12056: "Audience Cloud - TWT",
  1858: "AdRoll",
  2859: "Magnetic",
  8746: "Numberly",
  12496: "Audience Cloud - YHO",
  11996: "Audience Cloud - FBK",
  12026: "Audience Cloud - AOL",
  12556: "Audience Cloud - MSN",
  12516: "Audience Cloud - 4IN",
  12476: "Audience Cloud - EBY",
  12546: "Audience Cloud - 9DC",
  7206: "Kargo ",
  11419: "Dianomi",
  11876: "AdKernel",
  11579: "Quaero",
  1468: "OwnerIQ",
  6156: "Tru Optik",
  6486: "SundaySky",
  12596: "LKQD Technologies",
  10409: "Disney Ad Sales (fka Hulu/ESPN/ABC)",
  6226: "Vistar Media",
  11249: "Choozle",
  9066: "Adsquare",
  13066: "Dynadmic",
  12956: "CraveLabs",
  13406: "MobileFuse",
  12716: "LiveRamp TV",
  13366: "Nextdoor",
  5306: "Sito",
  10069: "Spotad",
  13646: "Data Innovators",
  7756: "Cxense",
  4236: "Millward Brown",
  12756: "Juice Mobile",
  13956: "Connect:Select",
  6546: "Beeswax ",
  14096: "Acxiom Marketplace",
  13976: "Charter/Spectrum",
  4526: "DirecTV",
  14306: "NYI/Altice",
  4536: "Comcast",
  14186: "Dish/Sling TV",
  14336: "Audience Cloud - Linkedin",
  13986: "OneSpot",
  13216: "Active Agent",
  2609: "Flashtalking",
  8636: "Conversant Media",
  13876: "DeepIntent",
  4046: "PushSpring",
  7256: "Pinterest",
  14476: "Adcuratio",
  14536: "Datavant",
  10129: "TruSignal - Modeling Destination",
  15029: "CERT - Connect:Select",
  4696: "Cardlytics",
  11539: "iSpot",
  14556: "Reddit",
  14829: "Teads.tv",
  14759: "Quotient",
  4629: "Adara",
  2028: "Connexity",
  2519: "Quantcast",
  4116: "Swoop",
  15349: "Column6",
  15489: "Innovid - CTV",
  15469: "Verizon FiOS",
  6516: "Ubimo",
  15589: "A4 Media",
  4846: "Celtra",
  2048: "Simpli.fi",
  1808: "comScore",
  13156: "Powerlinks",
  15929: "Primis",
  9206: "Ziff Davis",
  15949: "Cox Media",
  16039: "MadHive - ID Sync ",
  13166: "Cognitiv (IBM Watson)",
  13926: "The Weather Company - IBM",
  13426: "Infillion (TrueX)",
  16139: "Firefly",
  16279: "RTBiQ",
  15889: "Ad.net",
  12786: "12 Digit Media",
  16459: "BigaBid",
  16479: "Parketer",
  16509: "Fox TV",
  15369: "NBC Universal",
  15849: "Permutive",
  16499: "Jamloop",
  16659: "Youappi",
  15669: "Fubo TV",
  16739: "Audience Cloud - DDP",
  6606: "Snapchat",
  6586: "Meredith",
  15809: "B2B:Select",
  7916: "Eyeota",
  14579: "Cars.com",
  16779: "LiveRamp Safe Haven (LSH) - Analytics Environment",
  16809: "4C Insights",
  16889: "VisionLTC",
  4386: "ConversionLogic",
  16689: "ZypMedia",
  16989: "ironSource",
  17006: "Parker Fake AdNetwork",
  16559: "iHeart Media [update]",
  15099: "Amazon",
  15919: "Nielsen TV",
  17146: "Ampersand",
  15679: "Viacom",
  12076: "LiveNation",
  12376: "MediaAlpha",
  17301: "Training Elie Destination Group",
  5176: "Simulmedia",
  17411: "Magnite (Telaria)",
  15739: "NYDB - US - CID",
  17099: "Discovery",
  14056: "Data + Math",
  17631: "Invibes",
  16709: "Rokt",
  7516: "FreeWheel",
  17661: "Hawkfish",
  17781: "WarnerMedia TV",
  17321: "Inula",
  17991: "Publica",
  18021: "Pelmorex",
  18121: "AJA",
  17431: "Cadreon - TV",
  18381: "NBCU:AdSmart",
  18401: "MainAd",
  18391: "RTB House",
  18371: "Twitch",
  17901: "AdSlot",
  18461: "Blockboard",
  17241: "Surfside",
  11816: "Centriply",
  18561: "Canoe",
  18581: "RBI - Burger King",
  6: "Nielsen Marketing Cloud",
  18781: "Market Resource Partners",
  17561: "OpenAP",
  15209: "AMC Networks",
  18821: "Stirista",
  17261: "Prodege-Destination",
  18891: "FreeWheel.TV_NEW",
  11696: "Index Exchange",
  15779: "Tabmo",
  19101: "Epsilon",
  19111: "Truthset",
  19141: "True Influence",
  19151: "FreeWheel.tv - SFX",
  18751: "Cognitiv - Destination",
  19221: "Vevo",
  19311: "Eli Lilly",
  19261: "GoodRx",
  19401: "1plusX",
  13416: "Edmunds",
  19191: "AudienceXpress (Freewheel)",
  19661: "Epicenter Experience",
  3206: "iponweb",
  19671: "Data Marketplace - Audience Solutions",
  17851: "Xandr Invest TV (formerly Xandr Data)",
  19441: "Omnicom - TV",
  16919: "Beachfront",
  16149: "Knorex",
  20141: "Philo TV",
  20111: "Bucksense",
  20131: "Transparent.ly",
  20161: "Mulesoft",
  7986: "Crimtan",
  4606: "Baidu",
  17136: "A&E Networks",
  16339: "CI Sandbox",
  20351: "Fyllo",
  20381: "Octillion Media",
  20421: "Origin Media",
  20521: "Univision",
  20551: "Gamoshi",
  19161: "TikTok",
  19331: "Blis",
  20651: "RD&X",
  20801: "Liftoff Mobile",
  18111: "Sinclair",
  20871: "Skincare.com",
  19971: "Platform161",
  20941: "Plex",
  1255: "PubMatic",
  15319: "Clear Channel",
  10589: "Walmart",
  21061: "Mountain",
  12386: "Sharethrough ",
  11776: "Disqus",
  21021: "Xumo",
  18511: "Media.Net",
  21191: "MSFT-AAIG",
  9166: "Smart AdServer (Equativ)",
  21051: "Healthline",
  21211: "Talon Outdoors",
  21271: "D2 Media Sales",
  21171: "MGID",
  13596: "Warner Media (FKA Turner)",
  21451: "Martin.ai",
  21591: "UPE customer platform test",
  5006: "OpenX",
  21621: "Swift.ly",
  21091: "SpringServe",
  20851: "Kirstie Test Ad Network",
  21991: "Disney Ad Sales",
  21961: "Ellie Test",
  22201: "Ask Locala",
  22311: "Campari",
  22081: "AdQuick",
  21461: "LEGACY -- LiveRamp Safe Haven - US",
  22611: "Flipp (Updated)",
  9256: "PadSquad",
  22321: "LiveRamp E2E Testing",
  21551: "annetteb test",
  21381: "Quinstreet - NEW",
  23041: "Chartboost",
  19551: "Place Exchange",
  18721: "Vizio Ads",
  23431: "Rebatus",
  23711: "Sportradar",
  21811: "[ Castiglione ] Test",
  23871: "Gimbal",
  23941: "DXagency",
  24311: "Outside Interactive",
  24281: "Netflix",
  24551: "Pixel Serving US",
  25161: "Lamark Media",
  21981: "Reset Digital",
  24611: "Yieldmo",
  23621: "Indeed",
  25611: "Hivestack",
  25921: "ArcSpan Technologies",
  22221: "Acast",
  4016: "ShareThis",
  13246: "Google Ad Manager",
  26391: "IndiCue",
  26441: "Cast Iron Media",
  26701: "Major League Baseball (MLB)",
};
